import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import LogoImg from "../assets/logo.svg";
import { RxHamburgerMenu } from "react-icons/rx";
import ThoughtLeadershipForm from "./BroucherDiv";
import NavbarLinks from "./NavbarLinks";
import { useClickOutside } from "../customHooks/clickOutside";
import HeartImg from "../assets/heartLogo3.svg";
import useProfile from "../customHooks/useProfile";
import { CiSearch } from "react-icons/ci";
import { MdQuestionMark } from "react-icons/md";
import { FaUser } from "react-icons/fa6";
import LogoPngImg from "../assets/Mothers-Pride-Logo-1024x283 6.png";

export default function Header({ bgColor }) {
  const [openModal, setOpenModal] = useState(false);
  const [hamburger, setHamburgerMenu] = useState(false);
  const hamburgerRef = useRef(null);
  const menuButtonRef = useRef(null);
  const { token } = useProfile();
  const [aboutOpen, setAboutOpen] = useState(false);
  const [curriculumOpen, setCurriculumOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");

  useClickOutside(
    hamburgerRef,
    () => {
      setHamburgerMenu(false);
    },
    menuButtonRef
  );

  const hoverRef = useRef(null);
  const curriTimeoutRef = useRef(null);
  function AboutMouseEnter() {
    if (hoverRef.current) {
      clearTimeout(hoverRef.current);
    }

    hoverRef.current = setAboutOpen(true);
  }

  function AboutMouseLeave() {
    hoverRef.current = setTimeout(() => {
      setAboutOpen(false);
    }, 400);
  }

  function CurriMouseEnter() {
    if (curriTimeoutRef.current) {
      clearTimeout(curriTimeoutRef.current);
    }
    setCurriculumOpen(true);
  }

  function CurriMouseLeave() {
    curriTimeoutRef.current = setTimeout(() => {
      setCurriculumOpen(false);
    }, 400);
  }

  function handleLinkClick(e, link) {
    e.stopPropagation();
    setSelectedLink(link);
  }

  return (
    <div
      className={`w-full h-[5rem]  sticky top-0 z-40`}
      style={{ backgroundColor: bgColor }}
    >
      <div
        className={
          "flex px-[1rem] lg:mx-[2rem] xl:mx-[4rem] h-full justify-between items-center relative "
        }
      >
        <div className="flex items-center justify-center">
          <Link to="/" onClick={() => setSelectedLink("")}>
            <img
              src={LogoPngImg}
              className="h-[42px] object-fit"
              alt="Mothers Pride Logo"
            />
          </Link>
        </div>

        {/* link if token is present or not  */}

        {!token ? (
          <div className=" hidden lg:flex items-center gap-5">
            <ul className="flex items-center font-normal justify-around text-center h-full gap-5 lg:gap-[2rem] text-[1.1rem]">
              {/* 1st link */}
              <li
                onClick={(e) => handleLinkClick(e, "about")}
                className={`navBtn ${
                  selectedLink === "about" ? "font-semibold text-red-600" : ""
                } relative cursor-pointer group`}
              >
                <Link
                  to="/about#first"
                  onMouseEnter={AboutMouseEnter}
                  onMouseLeave={AboutMouseLeave}
                >
                  About
                </Link>
                {/* about hover div */}
                {aboutOpen && (
                  <div
                    className="absolute w-[75vw] top-[52px] bg-[#D31C4F] rounded-lg text-white flex flex-row items-center xl:left-[-25vw] lg:left-[-20vw] md:left-[-30vw]"
                    onMouseEnter={AboutMouseEnter}
                    onMouseLeave={AboutMouseLeave}
                  >
                    <div className="h-7 w-7 rotate-45 bg-[#D31C4F] absolute top-[-10px] md:left-[20%] lg:left-[25%] xl:left-[35%] transform -translate-x-1/2"></div>
                    <div className="w-[20%] border-r border-white px-[2%] my-[2%]">
                      <img
                        src={HeartImg}
                        className="h-[100%] w-[100%]"
                        alt="heart"
                      />
                    </div>
                    <div className="w-[80%] pr-[7%] py-[3%] justify-around items-center flex">
                      <h1 className="font-bold text-[4rem] leading-[80px] font-Lato pointer-events-none">
                        About Us
                      </h1>
                      <div className="flex  flex-row px-[3%] gap-[5rem]">
                        <div className="flex flex-col gap-2 items-start">
                          <Link
                            to={"/about#vision"}
                            onClick={(e) => handleLinkClick(e, "vision")}
                            className={
                              selectedLink === "vision"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Vision
                          </Link>
                          <Link
                            to={"/about#mission"}
                            onClick={(e) => handleLinkClick(e, "mission")}
                            className={
                              selectedLink === "mission"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Mission
                          </Link>
                          <Link
                            to={"/about#who"}
                            onClick={(e) => handleLinkClick(e, "who")}
                            className={
                              selectedLink === "who"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Why Us
                          </Link>
                          <Link
                            to={"/about#leader"}
                            onClick={(e) => handleLinkClick(e, "leader")}
                            className={
                              selectedLink === "leader"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Our Leaders
                          </Link>
                          {/* <Link
                            to={"/about#teams"}
                            onClick={(e) => handleLinkClick(e, "teams")}
                            className={
                              selectedLink === "teams"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Meet The Team
                          </Link> */}
                          <Link
                            to={"/branch"}
                            onClick={(e) => handleLinkClick(e, "branch")}
                            className={
                              selectedLink === "branch"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Branch
                          </Link>
                        </div>
                        <div className="flex flex-col gap-2 items-start">
                          <Link
                            to={"/positiveParenting"}
                            onClick={(e) =>
                              handleLinkClick(e, "positiveParenting")
                            }
                            className={
                              selectedLink === "positiveParenting"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Positive Parenting
                          </Link>
                          <Link
                            to={"/about#story"}
                            onClick={(e) => handleLinkClick(e, "story")}
                            className={
                              selectedLink === "story"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Our Story
                          </Link>
                          <Link
                            to={"/about#awards"}
                            onClick={(e) => handleLinkClick(e, "awards")}
                            className={
                              selectedLink === "awards"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Awards
                          </Link>
                          <Link
                            to={"/about#groups"}
                            onClick={(e) => handleLinkClick(e, "group")}
                            className={
                              selectedLink === "group"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Our Group
                          </Link>
                          <Link
                            to={"/getinTouch"}
                            onClick={(e) => handleLinkClick(e, "getinTouch")}
                            className={
                              selectedLink === "getinTouch"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Get in Touch
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              {/* 2nd link */}
              <li
                className={`navBtn ${
                  selectedLink === "admission"
                    ? "font-semibold text-red-600"
                    : ""
                } relative cursor-pointer group`}
                onClick={(e) => handleLinkClick(e, "admission")}
              >
                <Link to={"/admission"}>Admission</Link>
              </li>

              {/* 3rd link */}
              <li
                className={`navBtn ${
                  selectedLink === "curricumOfLove"
                    ? "font-semibold text-red-600"
                    : ""
                } relative cursor-pointer group`}
                onMouseEnter={CurriMouseEnter}
                onMouseLeave={CurriMouseLeave}
                onClick={(e) => handleLinkClick(e, "curricumOfLove")}
              >
                <Link to="/curriculumOfLove">Curriculum of Love</Link>
                {curriculumOpen && (
                  <div
                    className="absolute w-[75vw] font-normal top-[50px] bg-[#D31C4F] rounded-lg text-white flex flex-row items-center xl:left-[-38vw] lg:left-[-30vw] md:left-[-40vw]"
                    onMouseEnter={CurriMouseEnter}
                    onMouseLeave={CurriMouseLeave}
                  >
                    <div className="h-7 w-7 rotate-45 bg-[#D31C4F] absolute top-[-10px] md:left-[40%] xl:left-[58%] transform -translate-x-1/2"></div>
                    <div className="w-[20%] border-r border-white px-[2%] my-[2%]">
                      <img
                        src={HeartImg}
                        className="h-[100%] w-[100%]"
                        alt="heart"
                      />
                    </div>
                    <div className="w-[80%] pr-[3%] py-[3%] justify-around flex">
                      <h1 className="font-bold w-[50%] text-[3.5rem] leading-[80px] font-Lato">
                        Curriculum of Love
                      </h1>
                      <div className="flex flex-row px-[2%] gap-[3rem]">
                        <div className="flex flex-col items-start gap-2">
                          <Link
                            to={"/curriculumOfLove"}
                            onClick={(e) =>
                              handleLinkClick(e, "curriculumOfLove")
                            }
                            className={
                              selectedLink === "curriculumOfLove"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Curriculum Of Love
                          </Link>
                          <Link
                            to={"/teachingMethod"}
                            onClick={(e) =>
                              handleLinkClick(e, "teachingMethod")
                            }
                            className={
                              selectedLink === "teachingMethod"
                                ? "underline underline-offset-2 text-left w-full"
                                : "text-white text-left w-full"
                            }
                          >
                            Teaching Methodology
                          </Link>
                          <Link
                            to={"/programs"}
                            onClick={(e) => handleLinkClick(e, "programs")}
                            className={
                              selectedLink === "programs"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Our programmes
                          </Link>
                          <Link
                            to={"/dignitory"}
                            onClick={(e) => handleLinkClick(e, "dignitory")}
                            className={
                              selectedLink === "dignitory"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Dignitaries
                          </Link>
                          <Link
                            to={"/facilities"}
                            onClick={(e) => handleLinkClick(e, "facilities")}
                            className={
                              selectedLink === "facilities"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Facilities
                          </Link>
                        </div>
                        <div className="flex flex-col items-start gap-2">
                          <Link
                            to={"/events"}
                            onClick={(e) => handleLinkClick(e, "events")}
                            className={
                              selectedLink === "events"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Events
                          </Link>
                          <Link
                            to={"/celebration"}
                            onClick={(e) => handleLinkClick(e, "celebration")}
                            className={
                              selectedLink === "celebration"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Celebrations
                          </Link>
                          <Link
                            to={"/activities"}
                            onClick={(e) => handleLinkClick(e, "activities")}
                            className={
                              selectedLink === "activities"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            Activities
                          </Link>
                          <Link
                            to={"/monthcal"}
                            onClick={(e) => handleLinkClick(e, "monthcal")}
                            className={
                              selectedLink === "monthcal"
                                ? "underline text-left underline-offset-2"
                                : "text-white text-left w-full"
                            }
                          >
                            Month at a glance
                          </Link>
                          <Link
                            to={"/calendar"}
                            onClick={(e) => handleLinkClick(e, "calendar")}
                            className={
                              selectedLink === "calendar"
                                ? "underline underline-offset-2"
                                : "text-white"
                            }
                          >
                            List of Holidays
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>

              {/* 4th link */}
              <li
                className={`navBtn ${
                  selectedLink === "thought" ? "font-semibold text-red-600" : ""
                } relative cursor-pointer group`}
                onClick={(e) => {
                  handleLinkClick(e, "thought");
                }}
              >
                <Link to={"/thoughtLeadership"}>Thought Leadership</Link>
              </li>

              {/* 5th link */}
              <li
                className={`navBtn ${
                  selectedLink === "getInTouch"
                    ? "font-semibold text-red-600"
                    : ""
                } relative cursor-pointer group`}
                onClick={(e) => handleLinkClick(e, "getInTouch")}
              >
                <Link to={"/getinTouch"} className="navBtn cursor-pointer">
                  Contact us
                </Link>
              </li>
            </ul>
            {/* parent's login button */}
            <div className="ml-[25px] text-center my-auto">
              <button
                onClick={(e) => handleLinkClick(e, "")}
                className={
                  "border-[2px] border-[#65B2C0]  rounded-xl text-[#65B2C0] px-6 py-1 lg:py-2 min-w-[150px] font-Lato"
                }
              >
                <Link to="/login" className={`font-Lato`}>
                  Parents Login
                </Link>
              </button>
            </div>
          </div>
        ) : (
          <div className="flex  flex-row items-center w-[80%] sm:w-[60%] lg:w-[60%] sm:justify-between justify-evenly font-Lato">
            {/* search */}
            <div className="text-black flex items-center sm:gap-[10px] rounded-md sm:rounded-[100px] text-[20px] sm:leading-6 border border-black sm:px-3 py-1 sm:py-[10px] w-[180px] sm:w-[70%] lg:w-[45%]">
              <CiSearch className="w-5 h-5 " />
              <input
                type="text"
                placeholder="Search"
                className="focus:outline-none bg-transparent sm:px-0 px-2"
              />
            </div>

            {/* profile Buttons */}
            <div className="flex gap-1 sm:gap-5">
              <Link to={"/faq"}>
                {" "}
                <MdQuestionMark className="h-10 w-10 p-3 text-white bg-[#333333] rounded-full " />
              </Link>
              <Link to={"/studentProfile"}>
                {" "}
                <FaUser className="h-10 w-10 p-3 text-white bg-[#333333] rounded-full " />
              </Link>
            </div>
          </div>
        )}

        {/* for mobile device view */}
        {!token && (
          <div
            ref={menuButtonRef}
            className="lg:hidden pr-1 cursor-pointer"
            onClick={() => setHamburgerMenu(!hamburger)}
          >
            <div
              className={`hamburger-icon ${hamburger ? "cross" : ""}`}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "30px",
                height: "20px",
              }}
            >
              <div
                className={`line ${hamburger ? "line1" : ""} ${
                  hamburger && "rotate-45 translate-y-[16px]"
                }`}
                style={{
                  height: "2px",
                  background: "black",
                  transition: "transform 0.3s, opacity 0.3s",
                }}
              ></div>
              <div
                className={`line ${hamburger ? "line2" : ""}`}
                style={{
                  height: "2px",
                  background: "black",
                  opacity: hamburger ? 0 : 1,
                  transition: "opacity 0.3s",
                }}
              ></div>
              <div
                className={`line ${hamburger ? "line3" : ""} ${
                  hamburger && "rotate-[135deg] translate-y-[-1px]"
                }`}
                style={{
                  height: "2px",
                  background: "black",
                  transition: "transform 0.3s",
                }}
              ></div>
            </div>
          </div>
        )}
        {hamburger && (
          <NavbarLinks
            bgColor={bgColor}
            setOpenModal={setHamburgerMenu}
            hamburgerRef={hamburgerRef}
          />
        )}

        {openModal && <ThoughtLeadershipForm setOpenModal={setOpenModal} />}
      </div>
    </div>
  );
}
